export const setAuth = (auth) => {
  return {
    type: 'SET_AUTH',
    auth,
  };
};

export const setExpiresIn = (expiresIn) => {
  return {
    type: 'SET_EXPIRES_IN',
    expiresIn,
  };
};

export const setTokenCreatedAt = (createdAt) => {
  return {
    type: 'SET_TOKEN_CREATED_AT',
    createdAt,
  };
};

export const setAuthUser = (user) => {
  return {
    type: 'SET_AUTH_USER',
    user,
  };
};

export const fetchAuthUser = (user) => {
  return {
    type: 'FETCH_AUTH_USER',
    payload: user,
  };
};

export const setAuthToken = (token) => {
  return {
    type: 'SET_AUTH_TOKEN',
    token,
  };
};

export const setAuthLoggedAs = (loggedAs) => {
  return {
    type: 'SET_AUTH_LOGGED_AS',
    loggedAs,
  };
};

export const setCurrentClient = (client) => {
  return {
    type: 'SET_CURRENT_CLIENT',
    payload: client
  };
};

export const updatePaymentClientsAuthorization = payload => ({
  type: 'UPDATE_PAYMENT_CLIENTS_AUTHORIZATION',
  payload
});

export const setUserLoggedWithToken = (user) => {
  return {
    type: 'SET_USER_LOGGED_WITH_TOKEN',
    payload: user,
  };
};



// WEBPACK FOOTER //
// ./app/actions/actions/auth.js